/**
* Card Set Three JS
* -----------------------------------------------------------------------------
*
* All the JS for the Card Set Three component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
( function( app ) {
  const COMPONENT = {

    className: 'card-set-three',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      gsap.registerPlugin( ScrollTrigger );
      $( '.green-border' ).each( function() {
        gsap.from( this, {
          scrollTrigger: {
            trigger: this,
            start: 'top 53%',
            scrub: false,
          },
          onStart: () => {
            this.classList.add( 'action' );
          },
        } );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'card-set-three', COMPONENT );
} )( app );
